import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  ClientsResponseDto
} from '../../interfaces/apiInterfaces';

export class FindDriversByContainsName extends IRequestCommand<
  ClientsResponseDto,
  ErrorDetails,
  IFindDriversByContainsNameCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/drivers?lastName=';
  override _needAuthenticate = true;
  public override setParameters(
    parameters: IFindDriversByContainsNameCommandParameters
  ) {
    this._commandUrl = this._commandUrl + parameters.terms.toString();
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
  }
}

export interface IFindDriversByContainsNameCommandParameters
  extends ICommandParameters {
  terms: string;
  carrierId: string;
}

export interface IFindDriversByContainsNameClientsResponse
  extends ClientsResponseDto,
  ICommandResponse {
  name?: string;
}
